import React,{useContext} from "react";
import Sidebar from "./Sidebar";
import TopBar from "./TopBar";
import "./Dashboard.css";
import { Outlet } from "react-router-dom";
import useGlobalAppContext from "../../hooks/useGlobalAppContext";
const DashBoard = (/*{ role, setAuth, userdata }*/) => {
  const {role,setAuth,userdata}=useContext(useGlobalAppContext)
  return (
    <div className="layout">
      <Sidebar userRole={"admin"} />
      <div className="content-area">
        <TopBar setAuth={setAuth} userdata={userdata} />
        <main className="main-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default DashBoard;
